import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import styles from './styles/ShoppingWithSocial.scss';
import FacebookIcon from 'dibs-icons/exports/legacy/Facebook';
import PinterestIcon from 'dibs-icons/exports/legacy/Pinterest';
import { useIntl, defineMessages } from 'dibs-react-intl';
import { shareViaFacebook, shareViaPinterest } from '../utils/shareHelpers';

const messages = defineMessages({
    shareText: {
        id: 'ShoppingWithSocial.pinterest',
        defaultMessage: 'Shopping with {name} | 1stDibs.com',
    },
});

function getShareOptions({ shoppingWith, intl }) {
    const url = document.location.toString();

    return {
        url,
        text: intl.formatMessage(messages.shareText, {
            name: shoppingWith.title,
        }),
    };
}

function ShoppingWithSocialComponent({ shoppingWith }) {
    const intl = useIntl();
    return (
        <Fragment>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/forbid-elements */}
            <a
                href="#"
                className={`${styles.iconWrapper} ${styles.pinterest}`}
                onClick={e => {
                    e.preventDefault();
                    const { url, text } = getShareOptions({ shoppingWith, intl });

                    shareViaPinterest({
                        description: `${text} ${url}`,
                        url,
                        media: shoppingWith.mainImage,
                    });
                }}
            >
                <PinterestIcon className={styles.icon} />
            </a>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, react/forbid-elements */}
            <a
                href="#"
                className={`${styles.iconWrapper} ${styles.facebook}`}
                onClick={e => {
                    e.preventDefault();
                    shareViaFacebook();
                }}
            >
                <FacebookIcon className={styles.icon} />
            </a>
        </Fragment>
    );
}

ShoppingWithSocialComponent.propTypes = {
    shoppingWith: PropTypes.object.isRequired,
};

export const ShoppingWithSocial = createFragmentContainer(ShoppingWithSocialComponent, {
    shoppingWith: graphql`
        fragment ShoppingWithSocial_shoppingWith on ShoppingWith {
            mainImage
            title
        }
    `,
});
